import { useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Tooltip } from "@mui/material";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import UnitsAndEnumsModal from "./UnitsAndEnumsModal";
import { closeEnumsGroupDialog, openEnumsGroupDialog } from "../state/enumsgroup/actions";
import { addNewEnumsGroupFile } from "../api/enumsgroupapi";
ModuleRegistry.registerModules([AllCommunityModule]);

let tempId = 600000;

const EnumsGroupGrid = ({result}) => {
  
  const dispatch                 =  useDispatch();
  const gridRef                  =  useRef();
  const [rowData, setRowData]    =  useState([]);
  const [columns,setColumns]     =  useState([]);
  const navigate                 =  useNavigate();
  const [formModalData, setFormModalData] = useState({
    releaseNotes:'',
    fileName: '',
    isLatest: false
  });

  const enumsGroupDialogBoxStatus  = useSelector((state) => state.enumGroupData.isEnumsGroupDialogOpen);

  useEffect(() => {
    const formattedData = () => {  
      const data = result.map((item,index) => {
        const key = Object.keys(item)[0];
        return {
          id: index + 1,
          labelId: parseInt(key),
          name: item[key],
          fromDB: true
        };
      });
      setRowData(data);

      const columnDefs = [
      { 
        headerName: 'label ID', 
        field: 'labelId',
        resizable: false,
        sortable: false,
        width:350
      },
      { 
        headerName: 'Name', 
        field: 'name',
        resizable: false,
        sortable: false,
        width:450,
        editable:true
      },
      { 
        headerName: 'Actions', 
        resizable: false,
        sortable: false,
        width:400,
        cellRenderer: (params) => {
          if (!params.data.fromDB) {
            return (
              <Tooltip title="Delete">
                <DeleteIcon 
                  onClick={() => handleDelete(params.data)} 
                  color="error" 
                  sx={{cursor:'pointer',mt:1}} 
                  fontSize="small"
                />
              </Tooltip>
            );
          }
          return null;
        }
      }
    ];
    setColumns(columnDefs);
    } 
    formattedData();
  }, [result]);


  const handleGoBack = () => {
    navigate('/web/enum-groups');
  };


  const handleAddRow = () => {
    if (!gridRef.current) return;
    const allRows = [];
    gridRef.current?.forEachNode((node) => allRows.push(node.data));

    const keys = columns
    .map((c) => c.field)
    .filter((f) => f !== "actions" && f !== "id" && f !== "fromDB");

    const lastLabel = allRows.length > 0 ? allRows[allRows.length - 1].labelId : 0;

    const newRow = keys.reduce(
    (acc, key) => ({ ...acc, [key]: key === "labelId" ? (parseInt(lastLabel) + 1) : "" }),
    { uniqueId: tempId++, fromDB: false,id: allRows.length + 1}
    );
    
    gridRef.current?.applyTransaction({ add: [newRow] });
  };

  const handleDelete = (row) => {
    if (!gridRef.current) return;

    gridRef.current.applyTransaction({ remove: [row] });

    const allNodes = [];
    gridRef.current.forEachNode((node) => allNodes.push(node));

    const lastDbRow = [...allNodes].reverse().find((n) => n.data.fromDB);
    let counter = lastDbRow ? lastDbRow.data.labelId + 1 : 1;

    allNodes.forEach((node) => {
      if (!node.data.fromDB) {
        node.setData({ ...node.data, labelId: counter++ });
      }
    });
  };

  const handleSave = () => {
    if (!gridRef.current) return;
    if(formModalData.length === 0 || formModalData.fileName === '' || formModalData.releaseNotes === ''){
        swal("Oops!", "Please fill required fields!", "error");
        return false;
    }
    const allRows = [];
    gridRef.current?.forEachNode((node) => allRows.push(node.data));
    const payload = allRows.map(item => {
      return { [item.labelId]: item.name };
    });
    const formData = new FormData(); 
    formData.append('fileContent', new Blob([JSON.stringify(payload)],{type:'application/json'}),'fileContent.txt');
    formData.append('fileName',formModalData.fileName)
    formData.append('releaseNotes',formModalData.releaseNotes);
    formData.append('isLatest',formModalData.isLatest);
    dispatch(addNewEnumsGroupFile(formData));
    dispatch(closeEnumsGroupDialog());
    handleGoBack();
  };

  const handleClickOpenRole = () => {
    document.activeElement.blur(); 
    dispatch(openEnumsGroupDialog());
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{paddingBottom:2}}>
          <Button onClick={handleGoBack} variant="contained">Back</Button>
          <Box display="flex" gap={2}> {/* Use gap for spacing between right buttons */}
              <Button variant="contained" color="secondary" onClick={handleAddRow}> Add Row </Button>
              <Button variant="contained" sx={{ ml: 2 }} onClick={handleClickOpenRole} > Create </Button>
          </Box>
      </Box>
      <div style={{ width: "100%", height: "500px" }}>
        <AgGridReact
          stopEditingWhenCellsLoseFocus={true}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columns}
          animateRows={true}
          suppressMovableColumns={true}
          getRowId={(params) => params.data.uniqueId ?? params.data.id}
          onGridReady={(params) => {
              // setGridApi(params.api); 
              gridRef.current = params.api;
          }}
        />
      </div>
      <UnitsAndEnumsModal 
          title={"Enum Groups New File"}
          open={enumsGroupDialogBoxStatus || false}
          value={formModalData}
          setFormModalData={setFormModalData}
          handleSave={handleSave}
      />
    </>
  );
};

export default EnumsGroupGrid;
